// src/pages/CalendarPage/EventCardUser.jsx
import React from "react";
import { FaCalendarAlt, FaMapMarkerAlt, FaInfoCircle } from "react-icons/fa";
import Button from "./../../components/Button/Button";

const EventCardUser = ({ event, userRole, onClick }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return isNaN(date)
      ? ""
      : date.toLocaleDateString("fr-FR", {
          day: "numeric",
          month: "long",
          year: "numeric",
        });
  };

  const handleCardClick = () => {
    if (onClick) onClick();
  };

  const handleMoreInfoClick = (e) => {
    e.stopPropagation();
    if (onClick) onClick();
  };

  const isEventPast =
    new Date(event.end || event.start).getTime() < new Date().getTime();

  const getTypeColor = (type) => {
    switch (type) {
      case "Cours commun Club":
        return "bg-yellow-500";
      case "Stage Club":
        return "bg-green-500";
      case "Tournoi Interclubs":
        return "bg-blue-500";
      case "Compétition":
        return "bg-red-500";
      case "Animation":
        return "bg-purple-500";
      case "Stage & Regroupement Technique":
        return "bg-indigo-500";
      case "Passage de Grade":
        return "bg-orange-500";
      default:
        return "bg-slate-500";
    }
  };

  const photo = event.photo_url || "/img/default_image.jpg";

  return (
    <div
      onClick={handleCardClick}
      className={`group relative flex flex-col overflow-hidden rounded-2xl border border-slate-200/80 dark:border-slate-700/80 shadow-md hover:shadow-xl hover:-translate-y-0.5 transition-all duration-200 bg-white/95 dark:bg-slate-900/95 cursor-pointer`}
    >
      {/* Image */}
      <div className="relative h-44 sm:h-52 bg-slate-200 dark:bg-slate-800 overflow-hidden">
        <img
          src={photo}
          alt={event.titre}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
        />

        {/* Overlay gradient */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/15 to-transparent" />

        {/* Badge type */}
        {event.type_event && (
          <div
            className={`absolute top-2 left-2 px-2.5 py-1 rounded-full text-[10px] font-semibold text-white shadow ${getTypeColor(
              event.type_event
            )}`}
          >
            {event.type_event}
          </div>
        )}

        {/* Badge statut */}
        {/* <div className="absolute top-2 right-2 px-2 py-1 rounded-full text-[10px] font-semibold text-white bg-black/50 backdrop-blur-sm">
          {isEventPast ? "Passé" : "À venir"}
        </div> */}
      </div>

      {/* Contenu */}
      <div className="flex flex-col flex-1 p-4">
        <div className="flex-1">
          <h3 className="text-sm sm:text-base font-bold text-slate-900 dark:text-white font-montserrat mb-1">
            {event.titre}
          </h3>

          {event.cate_event && (
            <p className="text-[11px] text-slate-500 dark:text-slate-300 mb-2">
              {event.cate_event}
            </p>
          )}

          <div className="text-xs text-slate-600 dark:text-slate-300 max-h-24 overflow-y-auto mb-3">
            {event.description && (
              <div
                dangerouslySetInnerHTML={{ __html: event.description }}
              />
            )}
          </div>

          <div className="space-y-1.5 text-xs text-slate-700 dark:text-slate-200">
            <div className="flex items-center gap-2">
              <FaCalendarAlt className="text-slate-400 text-xs" />
              <span>
                {formatDate(event.start)}
                {event.end &&
                  !isNaN(new Date(event.end).getTime()) &&
                  ` – ${formatDate(event.end)}`}
              </span>
            </div>
            <div className="flex items-center gap-2">
              <FaMapMarkerAlt className="text-slate-400 text-xs" />
              <span>{event.lieu_event || "Lieu à préciser"}</span>
            </div>
            {event.level_event && (
              <div className="text-[11px] text-slate-500 dark:text-slate-300">
                Niveau : {event.level_event}
              </div>
            )}
            {event.agenda_url && (
              <a
                href={event.agenda_url}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1 text-[11px] text-white/90 bg-black/50 hover:bg-black/70 px-2 py-1 rounded-full mt-1"
                onClick={(e) => e.stopPropagation()}
              >
                <FaInfoCircle className="text-[10px]" />
                Ajouter à votre agenda
              </a>
            )}
          </div>
        </div>

        {/* Bouton */}
        <div className="mt-3">
          <Button
            text="Plus d'infos"
            onClick={handleMoreInfoClick}
            icon={FaInfoCircle}
            className="w-full justify-center gap-2 text-xs sm:text-sm"
          />
        </div>
      </div>
    </div>
  );
};

export default EventCardUser;
